import * as URL from "../../configs/APIUrl";
import privateAPI from "../../rest_handlers/privateAPI";

export default class RequestIngredientService {
    static getAllRequestIngredient = params => privateAPI.get(
        `${URL.GET_REQUEST_INGREDIENT_LIST}`, {params}
    );
}
